<div class="aaguid-list">
    <div class="aaguid-input-row">
        <mat-form-field appearance="fill" class="aaguid-input">
            <mat-label>AAGUID</mat-label>
            <input
                matInput
                [(ngModel)]="inputValue"
                (ngModelChange)="onInputChange()"
                (keydown)="onKeydown($event)"
                [disabled]="disabled"
                placeholder="e.g. 08987058-cadc-4b81-b6e1-30de50dcbe96"
            />
            <mat-error *ngIf="inputError">{{ inputError }}</mat-error>
        </mat-form-field>
        <button mat-stroked-button type="button" (click)="addAaguid()" [disabled]="disabled || !inputValue.trim()">
            Add
        </button>
    </div>
    <div>
        <mat-checkbox
            [checked]="microsoftAuthenticatorsChecked"
            (change)="onMicrosoftAuthenticatorsChange($event.checked)"
            [disabled]="disabled"
            [matTooltip]="microsoftAuthenticatorTooltip"
            matTooltipClass="multiline-tooltip">
            Add Microsoft Authenticator
        </mat-checkbox>
    </div>
    <div *ngIf="inputError" class="aaguid-error">{{ inputError }}</div>

    <div *ngIf="value.length === 0" class="no-aaguids">No AAGUIDs added.</div>

    <div class="aaguid-chips">
        <div *ngFor="let aaguid of value" class="aaguid-chip">
            <span>{{ aaguid }}</span>
            <button mat-icon-button type="button" (click)="removeAaguid(aaguid)" [disabled]="disabled">
                <mat-icon>close</mat-icon>
            </button>
        </div>
    </div>
</div>
